export default "__VITE_ASSET__889dd9d7__"